import type { ButtonHTMLAttributes } from 'react';
import { resolveButtonClassName, type ButtonLook } from './button-classes';
import styles from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, Partial<ButtonLook> {}

export function Button({
  variant = 'primary',
  size = 'medium',
  shape = 'rectangle',
  prominent = false,
  className,
  type = 'button',
  children,
  ...buttonProps
}: ButtonProps): JSX.Element {
  return (
    <button
      type={type}
      className={resolveButtonClassName({ variant, size, shape, prominent }, className)}
      {...buttonProps}
    >
      <span className={styles.content}>{children}</span>
    </button>
  );
}
